var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgActoGray(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 59.534,
    height: 25.168,
    viewBox: "0 0 59.534 25.168",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1642",
    "data-name": "Grupo 1642",
    transform: "translate(-203.068 -47.35)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_462",
    "data-name": "Grupo 462",
    transform: "translate(203.068 47.35)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_548",
    "data-name": "Trazado 548",
    d: "M203.134,70.09l10.106-22.374a.6.6,0,0,1,.565-.366h.332a.6.6,0,0,1,.565.366l10.04,22.374a.587.587,0,0,1-.565.864h-1.33a.611.611,0,0,1-.565-.366l-2.46-5.485h-11.8l-2.427,5.485a.612.612,0,0,1-.565.366H203.7A.587.587,0,0,1,203.134,70.09Zm15.791-7.048c-1.629-3.624-3.225-7.281-4.854-10.9h-.266l-4.854,10.9Z",
    transform: "translate(-203.068 -47.35)",
    fill: "#58595b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_549",
    "data-name": "Trazado 549",
    d: "M259.149,61.2a5.739,5.739,0,0,1,4.754,2.327.651.651,0,0,1-.133.931l-.632.532c-.5.466-.664.133-.964-.133a4.1,4.1,0,0,0-3.059-1.4,4.768,4.768,0,0,0-.033,9.508,4.425,4.425,0,0,0,3.524-1.729c.4-.4.632-.333,1-.067l.365.266a.669.669,0,0,1,.233.931,5.96,5.96,0,0,1-5.087,2.792,6.833,6.833,0,0,1-6.815-6.948A7,7,0,0,1,259.149,61.2Z",
    transform: "translate(-231.022 -55.212)",
    fill: "#58595b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_550",
    "data-name": "Trazado 550",
    d: "M287.475,58.194h-1.7a.631.631,0,0,1-.631-.631v-.732a.611.611,0,0,1,.631-.631h1.7v-3.69a.654.654,0,0,1,.632-.632l1.064-.067a.625.625,0,0,1,.6.632V56.2h3.856a.611.611,0,0,1,.632.631v.732a.631.631,0,0,1-.632.631h-3.856v7.779c0,1.33.332,1.6,1.1,1.6a6.354,6.354,0,0,0,2.427-.731c.5-.266.631-.067.8.2l.5.831c.233.4.133.6-.233.831a8.689,8.689,0,0,1-3.823,1.13c-2.66,0-3.059-1.6-3.059-3.657Z",
    transform: "translate(-249.673 -49.883)",
    fill: "#58595b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_551",
    "data-name": "Trazado 551",
    d: "M316.816,61.2a6.991,6.991,0,1,1-6.616,6.948A6.816,6.816,0,0,1,316.816,61.2Zm0,11.8a4.577,4.577,0,0,0,4.322-4.854,4.342,4.342,0,1,0-8.644,0A4.577,4.577,0,0,0,316.816,73Z",
    transform: "translate(-263.898 -55.212)",
    fill: "#58595b"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_552",
    "data-name": "Trazado 552",
    d: "M324.09,102.671h-4.21a1.108,1.108,0,1,1,0-2.216h4.21a1.108,1.108,0,1,1,0,2.216Z",
    transform: "translate(-65.697 -30.153)",
    fill: "#58595b"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActoGray);
export default __webpack_public_path__ + "static/media/acto-gray.da572be6.svg";
export { ForwardRef as ReactComponent };